import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, PickaxeIcon, GiftIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productEdition, productImage, productImageAlt, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} volumi completi`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} bonus esclusivi`
}];
export function Hero() {
  const scrollToOffer = () => document.getElementById('offerta')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden" data-id="element-82" data-mp="sb1c3rh88373">
      <div className="flex h-1 w-full" aria-hidden="true" data-id="element-83" data-mp="s9gj46ak8sbc">
        <span className="flex-1 bg-slate-900" data-id="element-84" data-mp="nczvdd79wfys" />
        <span className="w-24 bg-sky-400" data-id="element-85" data-mp="neaz5d0pxnpw" />
        <span className="flex-1 bg-slate-900" data-id="element-86" data-mp="3d1scj2wkntvr" />
      </div>

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-87" data-mp="3cz5v8bjvq00c">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-slate-700 bg-slate-900 px-4 py-2 text-[11px] font-bold uppercase tracking-[.14em] text-white sm:text-xs" data-id="element-88" data-mp="384jur3fc5rv1">
          <PickaxeIcon className="h-4 w-4 shrink-0 text-sky-400" aria-hidden="true" data-id="element-89" data-mp="3e7uxlpdzerov" /> {productBrand} · {productEdition}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-90" data-mp="358rdqj6zq89b">
          <img src={productImage} alt={productImageAlt} className="mx-auto w-full" data-id="element-91" data-mp="2vgtzt4oll26w" />
        </motion.div>

        <div className="mt-8" data-id="element-92" data-mp="2hl9puyqujubm">
          <Button onClick={scrollToOffer} arrow className="w-full sm:w-auto" data-id="element-93" data-mp="2lla5untlgdks">
            Voglio l&apos;Edizione Docenti
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-white" data-id="element-94" data-mp="s3cloaja7jqk">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-slate-800 bg-slate-900 px-3 py-2" data-id="element-95" data-mp="id9t2bg2o7sr">
              <Icon className="h-3.5 w-3.5 text-sky-400" aria-hidden="true" data-id="element-96" data-mp="deyhnwa4pp8f" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}